import { useTranslation } from 'react-i18next';

import useEvents from 'lib/hooks/useEvents';
import ExpandCollapseTap from 'lib/Tracking/Srp/SearchFilters/ExpandCollapseTap';
import { Features } from 'lib/EventSchema';
import FeaturesTechnologyTap from 'lib/Tracking/Srp/SearchFilters/FeaturesTechnologyTap';
import { useFeaturesTechnologyFilter } from 'lib/hooks/useSrpFilters';

import FilterContainer from 'components/Shared/SearchFilter/FilterContainer';
import LabeledCheckBox from 'components/Shared/SearchFilter/CheckBox/LabeledCheckBox';

import { SrpFeaturesTechnologyName } from 'types/srpFilters';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';

const featureOptions: SrpFeaturesTechnologyName[] = [
  'backupCamera',
  'bluetooth',
  'entertainmentDVD',
  'handicapAccessible',
  'iPodAUXInput',
  'laneDepartureWarning',
  'leather',
  'navigationSystem',
  'roofRack',
  'sunroofMoonroof',
  '3rdRowSeats',
  'towing',
];

export default function FeaturesTechnologyFilter({
  expanded,
}: {
  expanded?: boolean;
}): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();
  const { value, setValue } = useFeaturesTechnologyFilter();

  const onToggle = (isExpanding: boolean): Promise<void> =>
    logger.log(
      ExpandCollapseTap({ feature: Features.featuresTechnology, isExpanding, sourcePage })
    );

  const onTap = (label: string, isSelected: boolean): void => {
    setValue({ ...value, [label]: isSelected });
    logger.log(FeaturesTechnologyTap(label, sourcePage));
  };

  return (
    <FilterContainer
      title={t('srp.filters.featuresTechnology.header')}
      expanded={expanded}
      onClick={onToggle}
    >
      <div className="features-technology-checkbox-container">
        {featureOptions.map((feature) => (
          <LabeledCheckBox
            key={feature}
            isChecked={value[feature]}
            label={t(`srp.filters.featuresTechnology.${feature}`)}
            onClick={(isSelected: boolean): void => onTap(feature, isSelected)}
          />
        ))}
      </div>
      <style jsx>
        {`
          .features-technology-checkbox-container {
            margin-bottom: 8px;
          }
        `}
      </style>
    </FilterContainer>
  );
}
